import React from 'react'
import { useHistory } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import {
  CFImage,
  CFIcon,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import LocationButton from './LocationButton'
// import { mobileLocationsBg } from 'images'
import { dispatch } from 'store'

export default ({ onRequestClose }) => {
  const history = useHistory()
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const changeLocation = locationId => {
    dispatch.restaurant.setLocationId(locationId)
    if (isMobile) {
      history.push('/')
    } else {
      onRequestClose()
    }
  }

  return (
    <>
      <MobileScreen>
        <CFSelect selector={dispatch.restaurant.getLocations}>
          {locations => {
            return (
              <CFView
                h="100%"
                w="100%"
                column
                center
                // image={`url(${mobileLocationsBg}) center / cover no-repeat`}
              >
                <CFImage
                  h="120px"
                  src={dispatch.restaurant.getImages().logo}
                  alt="Logo"
                />
                <CFView h3 bold white mv="20px">
                  Please choose a location:
                </CFView>
                <CFView column center w="100%">
                  {Object.values(locations)
                    .sort((a, b) => {
                      if (a.locationName < b.locationName) {
                        return -1
                      }
                      if (a.locationName > b.locationName) {
                        return 1
                      }
                      return 0
                    })
                    .map(location => (
                      <LocationButton
                        key={location.id}
                        name={location.locationName}
                        address={location.address}
                        onClick={() => changeLocation(location.id)}
                      />
                    ))}
                  <CFView
                    mb={20}
                    h={75}
                    w="90%"
                    br={8}
                    ph={19}
                    hover
                    bg="white"
                    row
                    center
                  >
                    <CFIcon icon="map-marker-alt" color="black" fontSize={30} />
                    <CFLink href="https://tsukisushibar.ca">
                      <CFView ml={20} fill>
                        <CFView h4 color="black" mb="3px">
                          Vancouver
                        </CFView>
                        <CFView h6 color="black">
                          509 Abbott St, Vancouver, BC V6B 6N7
                        </CFView>
                      </CFView>
                    </CFLink>
                  </CFView>
                </CFView>
              </CFView>
            )
          }}
        </CFSelect>
      </MobileScreen>
      <DefaultScreen>
        <CFView w="480px" pt="20px" pb="20px" ph="20px" column>
          <CFSelect selector={dispatch.restaurant.getLocations}>
            {locations => {
              return (
                <CFView fill column center>
                  <CFImage
                    h="100px"
                    src={dispatch.restaurant.getImages().logo}
                    alt="Logo"
                  />
                  <CFView h4 bold mv="20px">
                    Please choose a location:
                  </CFView>
                  {Object.values(locations)
                    .sort((a, b) => {
                      if (a.locationName < b.locationName) {
                        return -1
                      }
                      if (a.locationName > b.locationName) {
                        return 1
                      }
                      return 0
                    })
                    .map(location => (
                      <LocationButton
                        key={location.id}
                        name={location.locationName}
                        address={location.address}
                        onClick={() => changeLocation(location.id)}
                      />
                    ))}
                  <CFView
                    mb={20}
                    h={75}
                    w="90%"
                    br={8}
                    ph={19}
                    hover
                    bg="white"
                    row
                    alignCenter
                    justifyStart
                    boxShadow="1px 1px 3px rgba(0,0,0,.6)"
                  >
                    <CFIcon icon="map-marker-alt" color="black" fontSize={30} />
                    <CFLink href="https://tsukisushibar.ca">
                      <CFView ml={20} fill>
                        <CFView h4 color="black" mb="3px">
                          Vancouver
                        </CFView>
                        <CFView h6 color="black">
                          509 Abbott St, Vancouver, BC V6B 6N7
                        </CFView>
                      </CFView>
                    </CFLink>
                  </CFView>
                </CFView>
              )
            }}
          </CFSelect>
        </CFView>
      </DefaultScreen>
    </>
  )
}
